// extracted by mini-css-extract-plugin
module.exports = {"station-status":"StationStatus_station-status__3pH7F"};